type Config = {
  redirectUri: string;
  basePath: string;
  audience: string;
  connection: string;
  gitlabClientId: string;
  gitlabScope: string;
  gitlabDeveloperAccessLevel: string;
  gitlabPipelineRef: string;
  gitlabAuthUrl: string;
  gitlabUrl: string;
  gitlabPipelinePath: string;
  atlassianScopes: string;
  atlassianClientId: string;
  atlassianUiAuthUrl: string;
  msalClientId: string;
  msalAuthority: string;
  datadogApplicationId: string;
  datadogClientToken: string;
};

const config: Config = (window as any).config;

export default config;
